import { Navigate } from "react-router-dom"
import * as O from "fp-ts/Option"
import { pipe } from "fp-ts/function"
import { Loader2 } from "lucide-react"
import { useAuth } from "@/hooks/use-auth"
import { injectOrgSlug, resolveOrgSlug } from "@/lib/inject-org-slug"

/**
 * Redirige la racine "/" vers /<orgSlug>/dashboard si authentifié, sinon
 * vers /login. Utilise le helper `resolveOrgSlug` (source unique de vérité
 * pour la résolution du slug depuis localStorage puis user.tenant_code).
 */
export function RootRedirect() {
  const { isAuthenticated, isLoading, user } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    )
  }

  if (!isAuthenticated || user === null) {
    return <Navigate to="/login" replace />
  }

  return pipe(
    resolveOrgSlug(user),
    O.match(
      // Backend qui n'aurait pas hydraté tenant_code → reconnexion propre.
      () => <Navigate to="/login" replace />,
      (slug) => <Navigate to={injectOrgSlug("/dashboard", slug)} replace />,
    ),
  )
}
